import { Link, useMatches } from '@remix-run/react'
import { useBreadcrumbs } from 'react-aria'
interface Handle {
  breadcrumb?: string
}
interface BreadCrumb {
  name: string
  href: string
  onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
}
interface BreadCrumbsListProps {
  prependCrumbs?: BreadCrumb[]
}

export default function BreadCrumbsList({ prependCrumbs = [] }: BreadCrumbsListProps) {
  const { navProps } = useBreadcrumbs({})
  const matches = useMatches()

  const breadcrumbs = matches
    .map((match) => {
      const handle = match.handle as Handle | undefined
      return handle?.breadcrumb ? { name: handle.breadcrumb, href: match.pathname } : null
    })
    .filter(Boolean) as BreadCrumb[]

  const allCrumbs = [...prependCrumbs, ...breadcrumbs]

  return (
    <nav {...navProps} aria-label="Breadcrumb" className="mb-2 ml-2">
      <ol className="flex items-center space-x-2 text-sm text-gray-100">
        {allCrumbs.map((crumb, index) => (
          <li className="flex items-center justify-center" key={`${crumb.name}-${index}`}>
            {index < allCrumbs.length - 1 ? (
              <Link
                className="text-base text-gray-100 hover:underline"
                to={crumb.href}
                onClick={crumb.onClick}
              >
                {crumb.name}
              </Link>
            ) : (
              <span className="text-gray-100 font-semibold text-base cursor-default items-center">
                {crumb.name}
              </span>
            )}
            {index < allCrumbs.length - 1 && (
              <span aria-hidden="true" className="ml-2 text-gray-100 text-lg font-bold place-items-center">
                {'›'}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
